import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import { toast } from "react-toastify";
import intl from "../../i18n/intl";

const initialState = {
  data: [],
  record: null,
  requesting: false,
  error: null,
  action: null,
  query: {
    pageNo: 1,
    pageSize: 50,
    sortBy: "asc",
    sortColumn: "name",
    namePattern: "",
  },
};

const customIntl = intl();

const learningPathwaySlice = createSlice({
  name: "learningPathways",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    listRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
    listSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    listFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    setQuery: (state, action) => {
      state.query = {
        ...state.query,
        ...action.payload,
      };
    },
    createRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "create";
    },
    createSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "learning_program_create_success" })
      );
    },
    createFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    detailsRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "details";
      state.record = null;
    },
    detailsSuccess: (state, action) => {
      state.record = {
        ...state.record,
        ...action.payload.response,
      };
      state.requesting = false;
      state.error = null;
    },
    detailsFail: (state, action) => {
      state.record = null;
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    updateDetailRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "update";
    },
    updateDetailSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "learning_program" }),
          }
        )
      );
    },
    updateDetailFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    assignmentsRequest: (state, action) => {
      state.action = "assignment-list";
      state.requesting = true;
      state.error = null;
    },
    assignmentsSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      state.record = {
        ...state.record,
        assignments: action.payload.response,
      };
    },
    assignmentsFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    addAssignmentRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "assignment-create";
    },
    addAssignmentSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "assignment_create_success" })
      );
    },
    addAssignmentFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    deleteAssignmentRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "assignment-delete";
    },
    deleteAssignmentSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "assignment_delete_success" })
      );
    },
    deleteAssignmentFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
  },
});

export const {
  addAssignmentFail,
  addAssignmentRequest,
  addAssignmentSuccess,
  assignmentsFail,
  assignmentsRequest,
  assignmentsSuccess,
  createFail,
  createRequest,
  createSuccess,
  detailsFail,
  detailsRequest,
  detailsSuccess,
  listFail,
  listRequest,
  listSuccess,
  setQuery,
  updateDetailFail,
  updateDetailRequest,
  updateDetailSuccess,
  deleteAssignmentFail,
  deleteAssignmentRequest,
  deleteAssignmentSuccess,
} = learningPathwaySlice.actions;
export default learningPathwaySlice.reducer;
